@if (this.contractBase$ | async; as contractBase) {
  <div class="sub-header">
    <div class="sub-header-row border-top align-items-center px-1">
      <div class="row">
        @if (this.customActions$ | async; as customActions) {
          <div class="col">
            @for (action of customActions; track action.name + action.actionName) {
              <a
                [class]="action.buttonType | buttontypepipe"
                class="btn-sm btn"
                (click)="triggerStatusFlow(action.actionName, contractBase.id)"
                >
                {{ action.title }}
              </a>
            }
          </div>
        }
        @if (this.contractStatusFlows$ | async; as contractStatusList) {
          <div
            class="col-auto state-breadcrumb-col"
            >
            <div class="state-breadcrumb">
              @for (contractStatus of contractStatusList; track contractStatus.statusId) {
                <li
            [ngClass]="
              contractBase.statusId == contractStatus.status
                ? ['active-' + contractStatus.statusColor]
                : ''
            "
                  >
                  {{ contractStatus.label }}
                </li>
              }
            </div>
          </div>
        }
      </div>
    </div>
  </div>
}
